import { render, staticRenderFns } from "./AllergyModal.vue?vue&type=template&id=a51f0a2e"
import script from "./AllergyModal.vue?vue&type=script&lang=js"
export * from "./AllergyModal.vue?vue&type=script&lang=js"
import style0 from "./AllergyModal.vue?vue&type=style&index=0&id=a51f0a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports